window.addEventListener('DOMContentLoaded', function () {
    let iframeResize = {
        container: null,
        leadMedia: null,
        iframes: [],
        leadIframe: null,
        init: function () {
            this.domCache();
            if (this.iframes.length > 0) {
                this.setAspectRatio();
            }
            if (this.leadIframe !== null) {
                this.setAspectRatioLead();
            }
        },
        domCache: function () {
            this.container = document.querySelector('.masterhack__content');
            if (this.container === null) {
                return;
            }
            this.leadMedia = document.querySelector('.masterhack__media');

            this.iframes = this.container.querySelectorAll('iframe');
            this.leadIframe = this.leadMedia.querySelector('iframe');
        },
        setAspectRatio: function () {
            let width = this.container.offsetWidth;
            width = width > window.screen.width ? window.screen.width : width;

            this.iframes.forEach(function (target) {
                let itemSrc = target.getAttribute('src'),
                    regx = new RegExp(/instagram|twitter|apis.google.com/),
                    maxWidth = width;

                if (itemSrc && !itemSrc.match(regx)) {
                    if (itemSrc.indexOf('video') === -1 && itemSrc.indexOf('facebook') > -1 && maxWidth > 500) {
                        maxWidth = 500;
                    }
                    if (isNaN(parseInt(target.height)) || isNaN(parseInt(target.width))) {
                        target.height = 9;
                        target.width = 16;
                    }

                    target.setAttribute('data-aspectRatio', target.height / target.width);
                    target.removeAttribute('height');
                    target.removeAttribute('width');
                    target.setAttribute('width', maxWidth);
                    target.setAttribute('height', maxWidth * target.getAttribute('data-aspectRatio'));
                }
            });
        },
        setAspectRatioLead: function () {
            if (this.leadIframe === null) {
                return;
            }
            let width = this.leadMedia.offsetWidth;
            width = width > window.screen.width ? window.screen.width : width;

            let target = this.leadIframe;

            let itemSrc = target.getAttribute('src'),
                regx = new RegExp(/instagram|twitter|apis.google.com/),
                maxWidth = width;

            if (itemSrc && !itemSrc.match(regx)) {
                if (itemSrc.indexOf('video') === -1 && itemSrc.indexOf('facebook') > -1 && maxWidth > 500) {
                    maxWidth = 500;
                }
                if (isNaN(parseInt(target.height)) || isNaN(parseInt(target.width))) {
                    target.height = 9;
                    target.width = 16;
                }

                target.setAttribute('data-aspectRatio', target.height / target.width);
                target.removeAttribute('height');
                target.removeAttribute('width');
                target.setAttribute('width', maxWidth);
                target.setAttribute('height', maxWidth * target.getAttribute('data-aspectRatio'));
            }
        },
    };

    iframeResize.init();
});
